// eslint-disable-next-line import/no-relative-parent-imports
import router from '../../index'

const optionsChartsOverviewCount = function(list) {
  let id
  return {
    animation: false,
    events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
    onClick: function(event, array) {
      if (array.length) {
        router.push({
          name: 'notificationAgentAdminDetail',
          params: { id: id },
        })
      }
    },
    tooltips: {
      callbacks: {
        title: function(tooltipItems) {
          const data = list?.filter(
            (item) => item.label === tooltipItems[0].xLabel
          )
          return data[0]?.title
        },
        label: function(tooltipItems) {
          id = tooltipItems.xLabel
          return tooltipItems.yLabel + '人'
        },
      },
    },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          gridLines: {
            drawOnChartArea: false,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            suggestedMax: 10,
            min: 0,
            // stepSize:1
          },
        },
      ],
    },
  }
}

const datasetChartsOverviewCount = function(chartData) {
  return [
    {
      type: 'bar',
      backgroundColor: '#8bbd3d',
      data: chartData,
    },
  ]
}

const optionsChartsOverviewRead = function(list) {
  let id
  return {
    animation: false,
    events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
    onClick: function(event, array) {
      if (array.length) {
        router.push({
          name: 'notificationAgentAdminDetail',
          params: { id: id },
        })
      }
    },
    tooltips: {
      callbacks: {
        title: function(tooltipItems) {
          const data = list?.filter(
            (item) => item.label === tooltipItems[0].xLabel
          )
          return data[0]?.title
        },
        label: function(tooltipItems) {
          id = tooltipItems.xLabel
          if (!tooltipItems.datasetIndex) {
            return tooltipItems.yLabel + '%'
          }
          return tooltipItems.yLabel + '人'
        },
      },
    },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          display: true,
          position: 'left',
          id: 'y-axis-1',
          ticks: {
            min: 0,
            suggestedMax: 10,
          },
        },
        {
          display: true,
          position: 'right',
          id: 'y-axis-2',
          gridLines: {
            drawOnChartArea: false,
          },
          ticks: {
            min: 0,
            max: 100,
            callback: function(label, index, labels) {
              return label + '%'
            },
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            drawOnChartArea: false,
          },
        },
      ],
    },
  }
}

const datasetChartsOverviewRead = function(chartDataReadRate, chartDataRead) {
  return [
    {
      type: 'line',
      backgroundColor: '#f86c6b',
      borderColor: '#f86c6b',
      borderWidth: 2,
      fill: false,
      yAxisID: 'y-axis-2',
      data: chartDataReadRate,
    },
    {
      type: 'bar',
      backgroundColor: '#63c2de',
      yAxisID: 'y-axis-1',
      data: chartDataRead,
    },
  ]
}

const optionsChartsOverviewClick = function(list) {
  let id
  return {
    animation: false,
    events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
    onClick: function(event, array) {
      if (array.length) {
        router.push({
          name: 'notificationAgentAdminDetail',
          params: { id: id },
        })
      }
    },
    tooltips: {
      callbacks: {
        title: function(tooltipItems) {
          const data = list?.filter(
            (item) => item.label === tooltipItems[0].xLabel
          )
          return data[0]?.title
        },
        label: function(tooltipItems) {
          id = tooltipItems.xLabel
          if (!tooltipItems.datasetIndex) {
            return tooltipItems.yLabel + '%'
          }
          return tooltipItems.yLabel + '人'
        },
      },
    },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          display: true,
          position: 'left',
          id: 'y-axis-1',
          ticks: {
            min: 0,
            suggestedMax: 10,
          },
        },
        {
          display: true,
          position: 'right',
          id: 'y-axis-2',
          gridLines: {
            drawOnChartArea: false,
          },
          ticks: {
            min: 0,
            max: 100,
            callback: function(label, index, labels) {
              return label + '%'
            },
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            drawOnChartArea: false,
          },
        },
      ],
    },
  }
}

const datasetChartsOverviewClick = function(
  chartDataClickRate,
  chartDataClick
) {
  return [
    {
      type: 'line',
      backgroundColor: '#f86c6b',
      borderColor: '#f86c6b',
      borderWidth: 2,
      fill: false,
      yAxisID: 'y-axis-2',
      data: chartDataClickRate,
    },
    {
      type: 'bar',
      backgroundColor: '#cfa65f',
      yAxisID: 'y-axis-1',
      data: chartDataClick,
    },
  ]
}

const configChart = {
  optionsChartsOverviewCount,
  datasetChartsOverviewCount,

  optionsChartsOverviewRead,
  datasetChartsOverviewRead,

  optionsChartsOverviewClick,
  datasetChartsOverviewClick,
}

export default configChart
